// extracted by mini-css-extract-plugin
export default {"recipeListWrapper":"G9f8ad4","threeTileRecipeList":"G3ace1d"};